// src/app/modules/commissionClient/apis/requestsApi.ts

import axios, { AxiosResponse } from 'axios'
import { getTokenConfig } from '../../../../../src/auth'
import {
  ClientCommissionItem,
  CustomerItem
} from '../core/CommissionClient.model'

const BASE = `${process.env.REACT_APP_API_URL}`

/** 1) Listado de clientes para el Select */
export async function fetchCustomers(): Promise<CustomerItem[]> {
  const cfg = await getTokenConfig()
  const res: AxiosResponse<{ data: { customers: CustomerItem[] } }> =
    await axios.get(`${BASE}/admin/customers-payment-platform`, cfg)
  return res.data.data.customers
}

/** 2) Trae los overrides de un cliente y los mapea a ClientCommissionItem */
export async function fetchClientCommissions(
  customerId: number
): Promise<ClientCommissionItem[]> {
  const cfg = await getTokenConfig()
  const res: AxiosResponse<{
    data: { commissionOverrides: Array<{
      customerId: number
      techPartner: string
      pctBaseTech: string      // "2.00"
      pctBaseCommercial: string
      updatedAt: string
    }> }
  }> = await axios.get(
    `${BASE}/customers/${customerId}/partners/commission-default`,
    cfg
  )

  // mapeo a nuestro modelo
  return res.data.data.commissionOverrides.map(o => ({
    customerId:  o.customerId,
    techPartner: o.techPartner,
    // aquí escogemos pctBaseTech como "commission"
    commission:  parseFloat(o.pctBaseTech.replace(',', '.')),
    isDefault:   false
  }))
}

/** 3) Guarda/actualiza los overrides */
export async function saveClientCommissions(
  customerId: number,
  overrides: ClientCommissionItem[]
): Promise<void> {
  const cfg = await getTokenConfig()
  const res = await axios.put(
    `${BASE}/customers/${customerId}/partners/commission-default`,
    { commissionOverrides: overrides },
    cfg,
  )
  if (res.status !== 200) {
    throw new Error('Error al guardar las comisiones personalizadas')
  }
}
